import { AddressTypes } from '../../../interfaces/enums/address-types.enum';

export const ADDRESS_TYPES_TRANSLATION = new Map<AddressTypes, string>([
    [AddressTypes.office, 'PROFILE_COMMON.ENUM_TYPES.office'],
    [AddressTypes.home, 'PROFILE_COMMON.ENUM_TYPES.home'],
    [AddressTypes.work, 'PROFILE_COMMON.ENUM_TYPES.work'],
    [AddressTypes.other, 'PROFILE_COMMON.ENUM_TYPES.other'],
]);